<template>
  <div class="adminLayoutBox">
    <div class="adminLayout_1">
      <div data-title="统计" class="adminLayout_1_statistics">
        <div>
          <m-statistics :statistics-data="statisticsData"></m-statistics>
        </div>
      </div>
      <div data-title="" class="adminLayout_1_user">
        <m-title title-text="新增注册用户" tip-text="如所选时间范围内无新增用户，则不显示"></m-title>
        <div class="content-box">
          <div class="top">
            <div class="month-select">
              <m-slide-switch @change="monthChange" :hidden-status="hiddenTimeSwitch"></m-slide-switch>
            </div>
            <div class="m-time-select">
              <el-date-picker
                v-model="dates"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期" style="height: 90%;" @change="registerUserTimeChange">
              </el-date-picker>
              <div class="time-mask">
                <div v-if="!dates.length">请选择时间段范围</div>
                <div v-else>{{ getDate(dates[0]) }}至{{ getDate(dates[1]) }}</div>
                <i class="el-icon-date"></i>
              </div>
            </div>
          </div>
          <div class="bottom">
            <m-chart :option-data="newRegisteredUserLineData" :showTip3="true"></m-chart>
          </div>
        </div>
      </div>
    </div>
    <div class="adminLayout_2" data-title="">
      <m-selects size="medium" :show-teacher-select="true" @change="selectChange"
                 @courseChange="()=>courseTabChange(1)"></m-selects>
    </div>
    <div class="adminLayout_3" data-title="">
      <m-title title-text="专业人数" :tip-text="tipText"></m-title>
      <m-course-tab @change="(type)=>courseTabChange(type,true)" :current-type="courseType"></m-course-tab>
      <div style="flex:1;width: 100%;">
        <m-chart :option-data="numberOfProfessionalsBarData"></m-chart>
      </div>
    </div>
    <div class="adminLayout_4" data-title="当前课程人数排行">
      <m-ranking-list style="margin-top: 50px"
                      :min-titles="numberOfProfessionalsTitles"
                      :headers="numberOfProfessionalsHeaders"
                      :ranking-list="numberOfProfessionalList"
                      :total="numberOfProfessionalList.total"
                      :loading="numberOfProfessionalList.loading"
                      @pageChange="(pageNum)=>numberOfProfessionalChange(numberOfProfessionalIndex, pageNum)">
        <template v-slot:tabHeader="headers">
          <div v-for="(item,index) in headers.data" :key="index" @click="numberOfProfessionalChange(index)">{{
              item.name
            }}
          </div>
        </template>
      </m-ranking-list>
    </div>
    <div class="adminLayout_5" data-title="">
      <m-title title-text="学习时长" :tip-text="tipText+'，显示从当前时间往前一周或一个月的数据'"></m-title>
      <div class="learningDuration">
        <m-chart :option-data="learningDurationBrokenLineData" :tip-style="tipStyle"></m-chart>
      </div>
      <div class="timeSwitchBox">
        <m-switch @change="timeSwitchChange"></m-switch>
      </div>
    </div>
    <div class="adminLayout_6" data-title="">
      <m-title title-text="学时排行"
               tip-text="该模块统计数字课程、实践教学的学习时长及讨论笔记等教学工具的使用时长"></m-title>
      <m-ranking-list style="margin-top: 30px"
                      :min-titles="{column3Name:learningDurationIndex?'学习时长':'平均学习时长',column2Name:learningDurationIndex?'学员':'班级'}"
                      :headers="learningDurationHeaders"
                      :ranking-list="learningDurationList"
                      :total="learningDurationList.total"
                      :loading="learningDurationList.loading"
                      :is-date="true"
                      @pageChange="(pageNum)=>learningDurationChange(learningDurationIndex,pageNum)">
        <template v-slot:tabHeader="headers">
          <div v-for="(item,index) in headers.data" :key="index" @click="learningDurationChange(index)">{{
              item.name
            }}
          </div>
        </template>
      </m-ranking-list>
    </div>
    <div class="adminLayout_7" v-if="false">
      <div data-title="课程进度">
        <div>
          <m-chart :option-data="courseProgressPieData"></m-chart>
          <div class="progress-content">{{ classProgress[0] }}%</div>
        </div>
      </div>
      <div data-title="课程实践练习进度">
        <div>
          <m-chart :option-data="coursePracticePieData"></m-chart>
          <div class="progress-content">{{ classProgress[1] }}%</div>
        </div>
      </div>
      <div data-title="实践教学进度">
        <div>
          <m-chart :option-data="practicalTeachingPieData"></m-chart>
          <div class="progress-content">{{ classProgress[2] }}%</div>
        </div>
      </div>
    </div>
    <div class="adminLayout_8" data-title="学习进度排行" v-if="false">
      <m-ranking-list style="margin-top: 30px" :min-titles="{column3Name:'进度'}" :headers="rateOfLearningHeaders"
                      :ranking-list="classProgressList"
                      :total="classProgressList.total"
                      @pageChange="(pageNum)=>classProgressChange(classProgressIndex,pageNum)">
        <template v-slot:tabHeader="headers">
          <div v-for="(item,index) in headers.data" :key="index" @click="classProgressChange(index)">{{
              item.name
            }}
          </div>
        </template>
      </m-ranking-list>
    </div>
    <div class="adminLayout_9" data-title="测验进度">
      <m-line-progress :progress="testProgress" progressClass="yellow" style="margin-bottom: 50px"></m-line-progress>
      <div class="cProgressBox">
        <m-circular-progress :score="testScore"></m-circular-progress>
      </div>
    </div>
    <div class="adminLayout_10" data-title="">
      <m-title title-text="测验分数" :tip-text="testTipText"></m-title>
      <div class="testScore">
        <m-chart :option-data="testScoreBrokenLineData"></m-chart>
      </div>
    </div>
  </div>
</template>

<script>
import mixinsData, {getBarData, getLineData, getPieData} from '../mixins';
import {
  classRankIng,
  findListInAdmin,
  getClassProgress,
  getClassProgressList,
  getExamPaperAvgScore,
  getExamProgress,
  getExamScoreList,
  numberOfProfessionalsAdmin,
  queryAdmin,
  queryClassByCourseId,
  queryMonthLyNewUser,
  queryRegisterDuration,
  queryStudent,
  queryTeacher,
  rankIngOfStudent,
  rankIngOfTeacher,
  selectClassNoPage,
  studentRankIng
} from "@/api/PostUrl";


export default {
  name: "adminLayout",
  mixins: [mixinsData],
  data() {
    return {
      currentSwitchTime: null,
      hiddenTimeSwitch: 0,
      learningDurationIndex: 0,
      learningDurationList: [],//学习时长排行-学生排行
      numberOfProfessionalIndex: 0,
      numberOfProfessionalList: [],//课程专业人数排行
      testProgress: 0,//测验进度
      testScore: 0,//测验平均分数
      courseType: '1',
      newRegisteredUserLineData: getLineData(['管理员', '教师', '学生'], '', '个'),
      numberOfProfessionalsBarData: getBarData(['未学人数', '在学人数', '已学人数'], '', '个'),
      courseProgressPieData: getPieData(),
      coursePracticePieData: getPieData(),
      practicalTeachingPieData: getPieData(),
      testScoreBrokenLineData: getLineData(['班级最低分', '班级平均分', '班级最高分'], '', '分'),
      learningDurationBrokenLineData: getLineData(['学习时长'], '', '秒'),
      dates: [],
      classProgress: [0, 0, 0],
      classProgressIndex: 0,
      classProgressList: [],//学习进度排行
      statisticsData: {
        runningDays: '',//运行时间
        adminCount: '',//管理员数据
        teacherCount: '',//教师数量
        studentCount: '',//学生数量
        teachingClassCount: '',//教学班数量
        administrativeCount: ''//行政班数量
      },
      numberOfProfessionalsTitles: {
        column2Name: '学员',
        column3Name: '选课量'
      },
      numberOfProfessionalsHeaders: [
        {
          name: '学生选课量'
        },
        {
          name: '教师授课学员数'
        },
      ],
      learningDurationHeaders: [
        {
          name: '教学班排行'
        },
        {
          name: '学生排行'
        },
      ],
      rateOfLearningHeaders: [
        {
          name: '课程整体'
        },
        {
          name: '课程实践练习'
        },
        {
          name: '实践教学'
        }
      ],
      fromData: {}
    }
  },
  computed: {
    getDate() {
      return function (dateVal) {
        if (!dateVal) return ''
        const date = new Date(dateVal)
        return date._$formatDate(date._$formats.zhAsDate)
      }
    }
  },
  mounted() {
    this.setCeiling()
    this.initFun()
  },
  methods: {
    initFun() {
      this.queryRegisterDuration()
      this.queryClassByCourseId()
      this.selectClassNoPage()
      this.queryAdmin()
      this.queryTeacher()
      this.queryStudent()
    },
    //设置吸顶
    setCeiling() {
      const headerWrapper = document.querySelector('.educa_wrap .header-wrapper')
      window.addEventListener('scroll', () => {
        const adminLayout_2 = document.querySelector('.adminLayoutBox .adminLayout_2')
        if (adminLayout_2) {
          const rect = adminLayout_2.getBoundingClientRect()
          if (rect.top === headerWrapper.offsetHeight) {
            adminLayout_2.style.borderRadius = '0 0 6px 6px'
            // adminLayout_2.style.minHeight = '70px'
            adminLayout_2.style.boxShadow = '0 0 15px #f0f0f3'
          } else {
            // adminLayout_2.style.minHeight = ''
            adminLayout_2.style.borderRadius = ''
            adminLayout_2.style.boxShadow = ''
          }
        }
      }, true)
    },
    //查询运行天数
    async queryRegisterDuration() {
      const date = await this.$apiPost.httpGetForMap(queryRegisterDuration)
      this.statisticsData.runningDays = date || ''
    },
    //教学班数量
    async queryClassByCourseId() {
      const data = await this.$apiPost.httpPostForMap(queryClassByCourseId)
      const list = data || []
      this.statisticsData.teachingClassCount = list.length + '个'
    },
    //行政班
    async selectClassNoPage() {
      selectClassNoPage.params.school_id = sessionStorage.getItem('deptId')
      const data = await this.$apiPost.httpPostForMap(selectClassNoPage)
      this.statisticsData.administrativeCount = (data ? data.total : 0) + '个'
    },
    //管理员人数
    async queryAdmin() {
      const count = await this.$apiPost.httpPostForMap(queryAdmin)
      this.statisticsData.adminCount = (count || 0) + '人'
    },
    //教师人数
    async queryTeacher() {
      const count = await this.$apiPost.httpPostForMap(queryTeacher)
      this.statisticsData.teacherCount = (count || 0) + '人'
    },
    //学生人数
    async queryStudent() {
      const count = await this.$apiPost.httpPostForMap(queryStudent)
      this.statisticsData.studentCount = (count || 0) + '人'
    },
    async monthChange(item) {
      const param = {
        timeRange: item.month,
        startTime: '',
        endTime: ''
      }

      const date = await new Date()._$getServerTime()
      this.$set(this.dates, 0, date._$skipTime(0, -item.month)._$formatDate(date._$formats.enAsDate))
      this.$set(this.dates, 1, date._$formatDate(date._$formats.enAsDate))
      await this.queryMonthLyNewUser(param)
    },
    registerUserTimeChange() {
      const param = {
        timeRange: '',
        startTime: this.dates[0],
        endTime: this.dates[1],
      }
      ++this.hiddenTimeSwitch
      this.queryMonthLyNewUser(param)
    },
    //查询新增注册人数
    async queryMonthLyNewUser(param) {
      const data = await this.$apiPost.httpPostForMap(queryMonthLyNewUser, param)
      this.setNewRegisteredUserLineData(data || [])
    },
    setNewRegisteredUserLineData(data) {
      this.newRegisteredUserLineData.xAxis.data = data.map(item => item.createTime)
      const keys = ['adminNum', 'teacherNum', 'studentNum']
      keys.forEach((key, index) => this.newRegisteredUserLineData.series[index].data = data.map(item => item[key] > 0 ? item[key] : 0))
    },
    selectChange(fromData) {
      this.fromData = fromData
      this.getNumberOfProfessionals()
      this.getClassProgress()
      this.getExamProgress()
      this.getExamPaperAvgScore()
      this.getExamScoreList()
      this.timeSwitchChange(this.currentSwitchTime)
      this.classProgressChange(this.classProgressIndex)
      this.numberOfProfessionalChange(this.numberOfProfessionalIndex)
      this.learningDurationChange(this.learningDurationIndex)
    },
    courseTabChange(courseType, isTab) {
      this.courseType = courseType
      isTab && this.getNumberOfProfessionals()
    },
    //获取专业人数
    async getNumberOfProfessionals() {
      Object.assign(numberOfProfessionalsAdmin.params, this.fromData)
      if (String(this.courseType) !== '1') {
        numberOfProfessionalsAdmin.params.courseId = ''//如果是全部则传空
        numberOfProfessionalsAdmin.params.classId = ''//如果是全部则传空
      }
      const data = await this.$apiPost.httpPostForMap(numberOfProfessionalsAdmin)
      this.setNumberOfProfessionals(data || [])
    },
    //设置专业人数配置
    setNumberOfProfessionals(data = []) {
      const list = data.reduce((arr, item) => arr.concat(item.list), [])
      this.numberOfProfessionalsBarData.xAxis.data = list.map(item => item.courseName)
      const keys = ['unNum', 'studyNum', 'finNum']
      keys.forEach((key, index) => this.numberOfProfessionalsBarData.series[index].data = list.map(item => item[key] > 0 ? item[key] : 0))
    },
    //获取班级教学平均进度
    async getClassProgress(catalogType = '') {
      if (catalogType > 1) return
      getClassProgress.params.catalogType = catalogType
      Object.assign(getClassProgress.params, this.fromData)
      const data = await this.$apiPost.httpPostForMap(getClassProgress)
      if (catalogType === '') {
        catalogType = 0
      } else {
        catalogType++
      }
      this.setPieData(catalogType, data)
      await this.getClassProgress(catalogType)
    },
    setPieData(index = 0, data = 0) {
      this.$set(this.classProgress, index, data)
      const pies = [this.courseProgressPieData, this.coursePracticePieData, this.practicalTeachingPieData]
      pies[index].series[0].data[0].value = data
      pies[index].series[0].data[1].value = 100 - data
    },
    //获得测验平均进度
    async getExamProgress() {
      Object.assign(getExamProgress.params, this.fromData)
      const data = await this.$apiPost.httpPostForMap(getExamProgress)
      this.testProgress = (data || 0) * 1000 / 10
    },
    //获得测验平均分数
    async getExamPaperAvgScore() {
      Object.assign(getExamPaperAvgScore.params, this.fromData)
      const data = await this.$apiPost.httpPostForMap(getExamPaperAvgScore)
      this.testScore = data || 0
    },
    //查询测验分数分布范围 折线图
    async getExamScoreList() {
      const data = await this.$apiPost.httpPostForMap(getExamScoreList, this.fromData)
      this.setTestScoreBrokenLineData(data || [])
    },
    //设置测验分数分布范围配置
    setTestScoreBrokenLineData(data = []) {
      this.testScoreBrokenLineData.xAxis.data = data.map(item => item.paperName)
      let maxScore = null
      if (data.length) {
        maxScore = Math.max.apply(null, data.map(item => item.maxScore))
      }
      this.setFractionYAxisMax(this.testScoreBrokenLineData, maxScore)
      const keys = ['minScore', 'avgScore', 'maxScore']
      keys.forEach((key, index) => this.testScoreBrokenLineData.series[index].data = data.map(item => item[key] > 0 ? item[key] : 0))
      this.testScoreBrokenLineData.additionalInfo = {
        title: '所在目录',
        values: data,
        key: 'lastCatalogName'
      }
    },
    //学习时长折线图
    async findListInAdmin(startDate, endDate) {
      findListInAdmin.params.classId = this.fromData.classId
      findListInAdmin.params.courseId = this.fromData.courseId
      findListInAdmin.params.startDate = this.fromData.startDate
      findListInAdmin.params.endDate = this.fromData.endDate
      findListInAdmin.params.teacherUserId = this.fromData.userId
      if (startDate && endDate) {
        findListInAdmin.params.startDate = startDate
        findListInAdmin.params.endDate = endDate
      }
      const data = await this.$apiPost.httpPostForMap(findListInAdmin)
      this.setLearningDurationBrokenLineData(data || [])
    },
    setLearningDurationBrokenLineData(data = []) {
      this.learningDurationBrokenLineData.xAxis.data = data.map(item => item.studyDate)
      const keys = ['time']
      keys.forEach((key, index) => this.learningDurationBrokenLineData.series[index].data = data.map(item => item[key] > 0 ? item[key] : 0))
    },
    numberOfProfessionalChange(index, pageNum) {
      this.$set(this.numberOfProfessionalList, 'loading', true)
      this.numberOfProfessionalIndex = index
      if (index === 0) {
        this.numberOfProfessionalsTitles = {
          column2Name: '学员',
          column3Name: '选课量'
        }
        this.rankIngOfStudent(pageNum)
      } else if (index === 1) {
        this.numberOfProfessionalsTitles = {
          column2Name: '教师',
          column3Name: '学员数'
        }
        this.rankIngOfTeacher(pageNum)
      }
    },
    //课程学员排行榜
    async rankIngOfStudent(pageNum = 1) {
      Object.assign(rankIngOfStudent.params, this.fromData)
      rankIngOfStudent.params.pageNum = pageNum
      const data = await this.$apiPost.setFinallyCall(() => this.$set(this.numberOfProfessionalList, 'loading', false)).dataForceObject().httpPostForMap(rankIngOfStudent)
      const list = data.list || []
      this.numberOfProfessionalList = list.map(({name, joinCount: content}) => ({name, content}))
      this.numberOfProfessionalList.total = data.total
    },
    //课程学员排行榜
    async rankIngOfTeacher(pageNum = 1) {
      Object.assign(rankIngOfTeacher.params, this.fromData)
      rankIngOfTeacher.params.pageNum = pageNum
      const data = await this.$apiPost.setFinallyCall(() => this.$set(this.numberOfProfessionalList, 'loading', false)).dataForceObject().httpPostForMap(rankIngOfTeacher)
      const list = data.list || []
      this.numberOfProfessionalList = list.map(({name, joinCount: content}) => ({name, content}))
      this.numberOfProfessionalList.total = data.total
    },
    learningDurationChange(index, pageNum) {
      this.learningDurationIndex = index
      this.$set(this.learningDurationList, 'loading', true)
      if (index === 0) {
        this.classRankIng(pageNum)
      } else if (index === 1) {
        this.studentRankIng(pageNum)
      }
    },
    //学习时长排行-学生排行
    async studentRankIng(pageNum = 1) {
      Object.assign(studentRankIng.params, this.fromData)
      studentRankIng.params.pageNum = pageNum
      const data = await this.$apiPost.setFinallyCall(() => this.$set(this.learningDurationList, 'loading', false)).dataForceObject().httpPostForMap(studentRankIng)
      const list = data.list || []
      this.learningDurationList = list.map(({name, time: content}) => ({name, content}))
      this.learningDurationList.total = data.total
    },
    //学习时长排行-班级排行
    async classRankIng(pageNum = 1) {
      Object.assign(classRankIng.params, this.fromData)
      classRankIng.params.pageNum = pageNum
      const data = await this.$apiPost.setFinallyCall(() => this.$set(this.learningDurationList, 'loading', false)).dataForceObject().httpPostForMap(classRankIng)
      const list = data.list || []
      this.learningDurationList = list.map(({className: name, time: content}) => ({name, content}))
      this.learningDurationList.total = data.total
    },
    //课程整体、课程实践、 实践教学排行
    classProgressChange(index, pageNum) {
      this.classProgressIndex = index
      this.$set(this.classProgressList, 'loading', true)
      this.getClassProgressList(index, pageNum)
    },
    async getClassProgressList(catalogType, pageNum = 1) {
      Object.assign(getClassProgressList.params, this.fromData)
      getClassProgressList.params.catalogType = catalogType || ''
      getClassProgressList.params.pageNum = pageNum
      const data = await this.$apiPost.setFinallyCall(() => this.$set(this.classProgressList, 'loading', true)).dataForceObject().httpPostForMap(getClassProgressList)
      this.classProgressList = data.list || []
      this.classProgressList.total = data.total
    },
    async timeSwitchChange(item) {
      await this.weekMonthChange(item, this.findListInAdmin)
    },
  }
}
</script>

<style scoped lang="scss">
.adminLayoutBox {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: calc(0.12 * var(--fontSize));

  div[data-title]:before {
    display: block;
    content: attr(data-title);
    position: absolute;
    left: calc(0.3 * var(--fontSize));
    top: calc(0.23 * var(--fontSize));
    font-size: calc(0.18 * var(--fontSize));
  }

  div[data-title] {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    background-color: white;
    position: relative;
    overflow: hidden;
  }

  & > div.adminLayout_1 {
    grid-column: 1 / span 3;
    height: calc(4.00 * var(--fontSize));
    min-height: 400px;
    background-color: transparent;
    display: grid;
    grid-template-columns: 1fr 1.3fr;
    gap: calc(0.12 * var(--fontSize));

    & > .adminLayout_1_statistics {
      display: flex;
      justify-content: center;
      align-items: center;

      & > div:nth-of-type(1) {
        width: calc(6.3 * var(--fontSize));
        height: calc(2.85 * var(--fontSize));
        margin-top: 10px;
      }
    }

    & > .adminLayout_1_user {
      display: flex;
      align-items: flex-end;
      position: relative;

      & > .content-box {
        width: 100%;
        height: 85%;
        display: flex;
        flex-direction: column;

        & > .top {
          width: 100%;
          height: calc(0.36 * var(--fontSize));
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 6%;
          box-sizing: border-box;
          position: relative;

          & > .month-select {
            height: 100%;
            width: calc(2.70 * var(--fontSize));
          }

          & > .m-time-select {
            height: 100%;
            width: calc(3.2 * var(--fontSize));
            border-radius: calc(0.06 * var(--fontSize));
            font-size: calc(0.12 * var(--fontSize));
            overflow: hidden;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            white-space: nowrap;

            & > .time-mask {
              width: 100%;
              height: 100%;
              color: #919191;
              cursor: pointer;
              display: flex;
              justify-content: space-between;
              align-items: center;
              position: absolute;
              background: linear-gradient(180deg, rgba(221, 228, 235, 1) 0%, rgba(233, 237, 242, 1) 9.91%, rgba(250, 250, 250, 1) 100%);
              left: 0;
              top: 0;
              z-index: 9;
              padding: 0 12px;
              box-sizing: border-box;
              pointer-events: none;

              i {
                color: black;
                font-size: calc(0.16 * var(--fontSize));
              }
            }
          }
        }


        & > .bottom {
          width: 100%;
          flex: 1;
        }
      }

    }
  }

  & > div.adminLayout_2 {
    grid-column: 1 / span 3;
    height: calc(1.1 * var(--fontSize));
    min-height: 110px;
    position: sticky;
    top: 0;
    z-index: 999;
  }

  & > div.adminLayout_3 {
    grid-column: 1 / span 2;
    height: calc(3.88 * var(--fontSize));
    min-height: 388px;
    display: flex;
    flex-direction: column;
    position: relative;
  }

  & > div.adminLayout_4 {
    height: calc(3.88 * var(--fontSize));
    min-height: 388px;
  }

  & > div.adminLayout_5 {
    grid-column: 1 / span 2;
    height: calc(3.88 * var(--fontSize));
    min-height: 388px;

    .learningDuration {
      width: 100%;
      height: 100%;
    }

    .timeSwitchBox {
      position: absolute;
      z-index: 99;
      top: 12%;
      right: 6%;
    }
  }

  & > .adminLayout_6 {
  }

  & > div.adminLayout_7 {
    grid-column: 1 / span 2;
    height: calc(3.88 * var(--fontSize));
    min-height: 388px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: calc(0.12 * var(--fontSize));

    & > div > div {
      width: calc(2.14 * var(--fontSize));
      height: calc(2.14 * var(--fontSize));
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      & > div.progress-content {
        position: absolute;
        font-size: calc(0.29 * var(--fontSize));
      }
    }
  }

  & > div.adminLayout_8 {

  }

  & > div.adminLayout_9 {
    height: calc(4.60 * var(--fontSize));
    min-height: 460px;
    display: flex;
    flex-direction: column;
    justify-content: start;
    padding-top: 10px;
    box-sizing: border-box;

    .cProgressBox {
      width: calc(2.1 * var(--fontSize));
      height: calc(2.1 * var(--fontSize));
    }
  }

  & > div.adminLayout_10 {
    grid-column: 2 / span 2;
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: center;

    .testScore {
      height: 90%;
      width: 100%;
      position: relative;

      & > .selector {
        width: calc(2.8 * var(--fontSize));
        height: calc(0.36 * var(--fontSize));
        position: absolute;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        right: 5%;
        top: 7%;
        cursor: pointer;

        & > div.content-box {
          height: 100%;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: absolute;
          z-index: 9;
          border-radius: 8px;
          background: linear-gradient(180deg, rgba(243, 245, 247, 1) 0%, rgba(243, 245, 247, 1) 9.91%, rgba(242, 245, 247, 1) 100%);
          border: 1px solid rgba(255, 255, 255, 1);
          box-shadow: inset -6px -6px 15px 0px rgba(255, 255, 255, 1), inset 4px 4px 13px 0px rgba(222, 221, 227, 0.28);
          padding: 0 10px;
          box-sizing: border-box;

          & > .arrow {
            width: 8px;
            height: 8px;
            border-radius: 2px;
            border-top: 2px solid rgba(151, 151, 151, 1);
            border-right: 2px solid rgba(151, 151, 151, 1);
            transform: rotate(135deg);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/layout/adminLayout.vue